module.exports = __webpack_public_path__ + "img/attendanceHistory.1e2fff04.svg";